import { useWorkbook } from '@/context/WorkbookContext';
import { WorkbookPage } from '@/components/WorkbookPage';
import { CheckCircle2 } from 'lucide-react';

function TableOfContents() {
  var workbook = useWorkbook();
  var setCurrentPage = workbook.setCurrentPage;
  var formData = workbook.formData;
  var completedPages = formData.completedPages || [];
  
  function isComplete(id) {
    return completedPages.indexOf(id) !== -1;
  }
  
  function TocItem(props) {
    var id = props.id;
    var title = props.title;
    return (
      <button
        onClick={function() { setCurrentPage(id); }}
        className="w-full flex items-center gap-3 py-2 px-3 rounded-lg hover:bg-secondary/50 transition-colors text-left group"
      >
        {isComplete(id) ? (
          <CheckCircle2 className="h-4 w-4 text-success shrink-0" />
        ) : (
          <div className="w-4 h-4 rounded-full border border-border shrink-0" />
        )}
        <span className="flex-1 text-sm group-hover:text-primary">{title}</span>
      </button>
    );
  }
  
  function TocSection(props) {
    var title = props.title;
    var subtitle = props.subtitle;
    var children = props.children;
    return (
      <div className="mb-6">
        <h2 className="font-serif font-bold text-lg text-foreground">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground italic">{subtitle}</p>}
        <div className="space-y-1 pl-4 mt-2">{children}</div>
        <div className="h-px bg-border mt-4" />
      </div>
    );
  }
  
  return (
    <WorkbookPage pageId="toc" prevPage="how-to-use" nextPage="section-1-divider">
      <header className="mb-10 text-center">
        <h1 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4">Table of Contents</h1>
      </header>
      
      <TocSection title="Front Matter">
        <TocItem id="title" title="Title Page" />
        <TocItem id="copyright" title="Copyright & Disclaimers" />
        <TocItem id="how-to-use" title="How to Use This Workbook" />
        <TocItem id="toc" title="Table of Contents" />
      </TocSection>
      
      <TocSection title="Section I: Stability" subtitle="Building Your Foundation">
        <TocItem id="rule-1" title="Rule 1: Know Your Numbers" />
        <TocItem id="rule-2" title="Rule 2: The Multiple Account System" />
        <TocItem id="rule-3" title="Rule 3: The 10th & 25th Planning System" />
        <TocItem id="rule-4" title="Rule 4: Cut Spending Without Shame" />
      </TocSection>
      
      <TocSection title="Section II: Control" subtitle="Taking Charge of Your Money">
        <TocItem id="rule-5" title="Rule 5: Build Your Buffer (Emergency Fund)" />
        <TocItem id="rule-6" title="Rule 6: Plan for Irregular Expenses" />
        <TocItem id="rule-7" title="Rule 7: Spread Out Lump Sums" />
        <TocItem id="rule-8" title="Rule 8: The Debt Snowball Method" />
      </TocSection>
      
      <TocSection title="Section III: Growth" subtitle="Building Your Future">
        <TocItem id="rule-9" title="Rule 9: Understand Credit" />
        <TocItem id="rule-10" title="Rule 10: Housing Decisions" />
        <TocItem id="rule-11" title="Rule 11: Smart Borrowing (Cars & BNPL)" />
      </TocSection>
      
      <TocSection title="Section IV: Healing, Purpose & Impact" subtitle="Money and Meaning">
        <TocItem id="rule-12" title="Rule 12: Heal Your Money Story" />
        <TocItem id="rule-13" title="Rule 13: Find Your Purpose" />
        <TocItem id="rule-14" title="Rule 14: Entrepreneurship Basics" />
      </TocSection>
      
      <TocSection title="Section V: Capstone" subtitle="Your Life & Money Map">
        <TocItem id="life-money-map" title="Life & Money Map" />
        <TocItem id="commitment" title="Personal Commitment Statement" />
      </TocSection>
      
      <TocSection title="Section VI: Appendices" subtitle="Tools & Trackers">
        <TocItem id="glossary" title="Glossary of Money Terms" />
        <TocItem id="weekly-calculator" title="Weekly Average Calculator" />
        <TocItem id="check-in-sheets" title="10th/25th Check-In Sheets" />
        <TocItem id="debt-tracker" title="Debt Tracker" />
        <TocItem id="credit-checklist" title="Credit Checklist" />
        <TocItem id="emergency-tracker" title="Emergency Fund Tracker" />
        <TocItem id="irregular-planner" title="Irregular Expenses Planner" />
        <TocItem id="crisis-mode" title="Crisis Mode Rules" />
        <TocItem id="reset-page" title="Reset Page" />
      </TocSection>
      
      <TocSection title="Back Matter">
        <TocItem id="program-description" title="Program Description (For Groups)" />
        <TocItem id="facilitator-note" title="Facilitator Note" />
      </TocSection>
    </WorkbookPage>
  );
}

export { TableOfContents };
